/**
 * @generated SignedSource<<270bd703bd098ae9662ac3e28d0f0ce3>>
 * @relayHash 5a4645bcaf2503ea67f13c86d97ab9c8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 02a4643ca0e349ca8c624de2062223517849626cae29b2c7563331f69d7883d8

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { backlogFilterRefinementQuery } from './backlogFilterRefinementQuery.graphql';

const node: PreloadableConcreteRequest<backlogFilterRefinementQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "02a4643ca0e349ca8c624de2062223517849626cae29b2c7563331f69d7883d8",
    "metadata": {},
    "name": "backlogFilterRefinementQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
